import { AfterViewInit, Component, effect, inject, Injector, Input, OnInit, runInInjectionContext, signal } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatOption, ThemePalette } from '@angular/material/core';
import { FloatLabelType, MatFormField, MatFormFieldAppearance, MatLabel } from '@angular/material/form-field';
import { MatSelect, MatSelectChange } from '@angular/material/select';

export const DEFAULT_LEAD_TIME_DAYS = 45;

// New-look replacement for app-lead-time-select. Defaults to 45 days when there's no initial value;
// disabled disables the control.
@Component({
  selector: 'app-lead-time-filter-select',
  templateUrl: './lead-time-filter-select.component.html',
  styleUrls: ['./lead-time-filter-select.component.scss'],
  imports: [MatFormField, MatLabel, MatSelect, MatOption, ReactiveFormsModule]
})
export class LeadTimeFilterSelectComponent implements OnInit, AfterViewInit {

  private readonly injector = inject(Injector);

  private readonly _disabled = signal(false);
  @Input() set disabled(value: boolean) {
    this._disabled.set(value);
  }

  get disabled(): boolean {
    return this._disabled();
  }

  @Input() form?: FormGroup;
  @Input() controlName = 'lead-time-select';
  @Input() required = true;
  @Input() initialValue: number | null | undefined = null;
  @Input() label: string | null = null;
  @Input() color: ThemePalette = 'primary';
  @Input() appearance: MatFormFieldAppearance = 'outline';
  @Input() floatLabel: FloatLabelType = 'auto';

  readonly filterOptions = [0, 15, 30, 45, 60].map(days => ({ label: `${days} Days`, value: days }));

  readonly control = new FormControl<number | null>(null);
  readonly valueChanged = signal<number | null>(null);
  readonly ready = signal(false);

  ngOnInit(): void {
    const value = this.initialValue ?? DEFAULT_LEAD_TIME_DAYS;
    this.control.setValue(value);
    this.valueChanged.set(value);

    if (this.required) {
      this.control.setValidators([Validators.required]);
    }

    this.form?.addControl(this.controlName, this.control);

    runInInjectionContext(this.injector, () => {
      effect(() => {
        if (this._disabled()) {
          this.control.disable({ emitEvent: false });
        } else {
          this.control.enable({ emitEvent: false });
        }
      });
    });
  }

  ngAfterViewInit(): void {
    this.ready.set(true);
  }

  onChange(event: MatSelectChange) {
    this.valueChanged.set(event.value);
  }
}
